import { t } from 'ttag'
import { useEffect, useMemo } from 'react'
import styled from 'styled-components'

import { Button } from '@h2/components/buttons/button'
import { Flex } from '@h2/components/layout/flex'
import { useForm } from '@h2/common/components/hooks/useForm'
import { Field } from '@h2/components/inputs/field'
import { TextInput } from '@h2/components/inputs/text'
import { DollarSmallIcon } from '@h2/components/icons'
import { PB80T } from '@h2/components/colors'

import { features } from '../../../components/media'

const MonthlyCostContainer = styled.form`
  @media (${features.maxWidth.desktop}) {
    width: 100%;
  }
  @media (${features.minWidth.desktop}) {
    display: flex;
    flex-direction: ${({ direction }) => direction};
    width: ${({ direction }) => (direction === 'row' ? '80%' : '40%')};
    margin: ${({ direction }) => (direction === 'row' ? 'auto' : 'initial')};
  }
`
const MonthlyCosts = styled.div`
  width: ${({ direction }) => (direction === 'row' ? '50%' : '100%')};
  border-radius: ${({ direction }) =>
    direction === 'row' ? '6px 0 0 6px' : '6px 6px 0 0'};
  padding: 25px 15px;
  border: 1px solid #ccc;
  background-color: #e6f2da;
  label {
    span {
      font-size: 22px;
    }
  }
`
const NextSection = styled.div`
  text-align: center;
  color: #000;
`
const SectionIcon = styled.div`
  height: 48px;
  width: 49px;
  display: inline-block;
  margin: 0;
  background-image: url('/images/common/iconset.png');

  &.locationsection {
    background-position: -58px -337px;
    height: 48px;
    width: 49px;
  }

  &.totalsection {
    background-position: -359px -518px;
  }

  &.earningssection {
    background-position: -5px -337px;
  }

  &.housingsection {
    background-position: -109px -337px;
  }

  &.utilitysection {
    background-position: -162px -337px;
  }

  &.foodsection {
    background-position: -213px -337px;
  }

  &.entertainmentsection {
    background-position: -267px -337px;
  }

  &.clothessection {
    background-position: -319px -337px;
  }

  &.transportationsection {
    background-position: -371px -337px;
  }

  &.educationsection {
    background-position: -422px -337px;
  }

  &.savingssection {
    background-position: -475px -337px;
  }

  &.healthinsurancesection {
    background-position: -471px -518px;
  }
`
const SectionName = styled.div``
const NavActions = styled.div`
  background-color: #eee;
  border-width: ${({ direction }) =>
    direction === 'column' ? '0 1px 1px 1px' : '1px 1px 1px 0'};
  border-style: solid;
  border-color: ${PB80T};
  padding: 15px;
  border-radius: ${({ direction }) =>
    direction === 'row' ? '0 6px 6px 0' : '0 0 6px 6px'};
  position: relative;
  height: ${({ direction }) => direction === 'column' && '100px'};
  @media (${features.minWidth.desktop}) {
    width: ${({ direction }) => direction === 'row' && '50%'};
  }
`
const RoundCost = ({
  value,
  rounds,
  currentRound,
  isSubmitting,
  onUpdateValue,
  direction = 'column'
}) => {
  const nextRound = useMemo(() => {
    const nextR = rounds
      .filter(round => !round.hideFromStepper)
      .find(round => round.roundId === currentRound + 1)

    return nextR
      ? nextR
      : {
          id: 'total',
          name: () => t`Total`
        }
  }, [currentRound, rounds])
  const { register, handleOnSubmit, dispatch } = useForm({
    initialValues: {
      monthlyCost: value
    }
  })

  useEffect(() => {
    dispatch({
      type: 'update',
      payload: {
        monthlyCost: value
      }
    })
  }, [dispatch, value])

  return (
    <MonthlyCostContainer
      direction={direction}
      onSubmit={handleOnSubmit(form => onUpdateValue(form))}>
      <MonthlyCosts direction={direction}>
        <Field isRequired={true} label={t`Monthly Cost`}>
          <Flex>
            <DollarSmallIcon />
            <TextInput {...register('monthlyCost', { required: true })} />
          </Flex>
        </Field>
      </MonthlyCosts>
      <NavActions direction={direction}>
        <Flex gap="15px" alignItems="center" width="100%" justifyContent="left">
          <div style={{ width: '100%' }}>
            <Button
              size="large"
              type="submit"
              isDisabled={value === '' || isSubmitting}
              isLoading={isSubmitting}>
              {t`Next Section`}
            </Button>
          </div>
          <NextSection>
            <SectionIcon className={`${nextRound.id}section`}></SectionIcon>
            <SectionName>{nextRound.name()}</SectionName>
          </NextSection>
        </Flex>
      </NavActions>
    </MonthlyCostContainer>
  )
}

export { RoundCost }
